import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/** The case id in the URL is a number everywhere downstream; a hand-typed `/case/abc` goes back to the list. */
export const caseIdGuard: CanActivateFn = route =>
    /^\d+$/.test(route.paramMap.get('id') ?? '') || inject(Router).createUrlTree(['/case-management/cases']);
